/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RegistryDiscoveryMetadata = {
  count: number;
  nextCursor?: string | undefined;
};

/** @internal */
export const RegistryDiscoveryMetadata$inboundSchema: z.ZodMiniType<
  RegistryDiscoveryMetadata,
  unknown
> = z.object({
  count: z.int(),
  nextCursor: z.optional(z.string()),
});

export function registryDiscoveryMetadataFromJSON(
  jsonString: string,
): SafeParseResult<RegistryDiscoveryMetadata, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RegistryDiscoveryMetadata$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RegistryDiscoveryMetadata' from JSON`,
  );
}
